import { createFileRoute } from '@tanstack/react-router';
import { ActividadesPage } from '@/components/ActividadesPage';

export const Route = createFileRoute('/_authenticated/actividades')({
  component: ActividadesPage,
});
